import React, { FunctionComponent } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { moveSelectedItemsForward } from '../../actions/annotations';

type Props = ReturnType<typeof mapDispatchToProps>;

const BringForward: FunctionComponent<Props> = ({ moveSelectedItemsForward }) => (
  <Tooltip disableInteractive disableFocusListener id="remove-page-tooltip" title="Bring Forward">
    <div>
      <IconButton sx={{ borderRadius: 0 }} aria-label="Bring Forward" onClick={moveSelectedItemsForward}>
        <KeyboardBackspaceIcon sx={{ transform: 'rotate(90deg)' }} />
      </IconButton>
    </div>
  </Tooltip>
);

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators({ moveSelectedItemsForward }, dispatch);
}

export default connect(null, mapDispatchToProps)(BringForward);
